/*
 * @Author: 田鑫
 * @Date: 2021-08-09 20:05:51
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-03-17 15:34:56
 * @Description: 文章管理
 */

export default [
  {
    name: "article",
    path: "/supplySystem/:supplyId/healthManagement/article",
    meta: { title: "文章管理" },
    component: require("business/supplySystem/healthManagement/article.vue").default
  },
  {
    name: "tag",
    path: "/supplySystem/:supplyId/healthManagement/tag",
    meta: { title: "标签管理" },
    component: require("business/supplySystem/healthManagement/tag.vue").default
  },
  {
    name: "healthFeedback",
    path: "/supplySystem/:supplyId/healthManagement/feedback",
    meta: { title: "反馈列表" },
    component: require("business/supplySystem/healthManagement/feedback/list.vue").default
  },
  {
    name: "healthFeedbackDetail",
    path: "/supplySystem/:supplyId/healthManagement/feedbackDetail",
    meta: { title: "反馈详情" },
    component: require("business/supplySystem/healthManagement/feedback/detail.vue").default
  },
  {
    name: "healthFeedbackCategory",
    path: "/supplySystem/:supplyId/healthManagement/category",
    meta: { title: "分类管理" },
    component: require("business/supplySystem/healthManagement/category.vue").default
  }
];
